import { PolicyGate } from '@/features/auth/authorization';
import { NextLeadButton } from '@/features/callcenter/components/NextLeadButton';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { FranchisePicker } from './TopBar/FranchisePicker';
import { NewLeadDialog } from './TopBar/NewLeadDialog';
import { WaitTime } from './TopBar/WaitTime';

interface HeaderProps {
  setMobileMenuOpen: (open: boolean) => void;
  children?: React.ReactNode;
}

export const Header = ({ setMobileMenuOpen, children }: HeaderProps) => {
  return (
    <>
      <PolicyGate policy="leads.view">
        {/* Exactly one of these renders: WaitTime hides itself for queue
            agents, NextLeadButton hides itself for everyone else. */}
        <div className="grow flex md:hidden">
          <WaitTime />
          <NextLeadButton />
        </div>
      </PolicyGate>

      <header className="w-full z-10 flex h-16 shrink-0 border-b bg-background">
        <button
          type="button"
          className="border-r px-4 text-foreground/40 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-primary md:hidden"
          onClick={() => setMobileMenuOpen(true)}
        >
          <span className="sr-only">Open sidebar</span>
          <Bars3Icon className="h-6 w-6" aria-hidden="true" />
        </button>
        <div className="flex flex-1 justify-between items-center px-4 sm:px-6">
          <PolicyGate policy="leads.view">
            <div className="grow pr-2 hidden md:flex">
              <WaitTime />
              <NextLeadButton />
            </div>
          </PolicyGate>
          <div className="flex items-center gap-2">
            <PolicyGate policy="leads.create">
              <span>
                <NewLeadDialog />
              </span>
            </PolicyGate>
            {children}
          </div>
          <div>
            <FranchisePicker />
          </div>
        </div>
      </header>
    </>
  );
};
